import { VHeaders } from '@/models/pagedlistmodel';

export function getAvailabilityHeaders(vm: any): VHeaders[] {
  return [
    {
      align: 'left',
      text: vm.$parent.$t(
        'availability.availabilityGridHeaders.store'
      ) as string,
      value: 'storeName',
    },
    {
      align: 'left',
      text: vm.$parent.$t(
        'availability.availabilityGridHeaders.availabilityStatus'
      ) as string,
      value: 'availabilityStatus',
    },
    {
      align: 'left',
      text: vm.$parent.$t(
        'availability.availabilityGridHeaders.alternateUserName'
      ) as string,
      value: 'alternateUserName',
    },
    {
      align: 'center',
      isNotDataProp: true,
      text: vm.$parent.$t(
        'availability.availabilityGridHeaders.action'
      ) as string,
      sortable: false,
    },
  ];
}
